export default "__VITE_ASSET__DsJEaNrs__"